import React, { useState } from 'react';

import { Text } from 'app/shopify/theme';
import { Column, Row } from 'app/shopify/components/layout';

import { Checkbox } from './Checkbox';
import { CheckboxList } from './CheckboxList';

const OPTIONS = [
  { value: 'a', label: 'Checkbox label' },
  { value: 'b', label: 'Checkbox label' },
  { value: 'c', label: 'Checkbox label' },
];

export function CheckboxShowcase() {
  const [selectedSmall, setSelectedSmall] = useState<string[]>(['a']);
  const [selectedLarge, setSelectedLarge] = useState<string[]>(['b']);

  function toggle(list: string[], value: string) {
    return list.includes(value) ? list.filter((item) => item !== value) : [...list, value];
  }

  return (
    <Column gap="spacing.general.x4" padding="spacing.general.x4">
      <Text variant="bodySmall" color="text.secondary">
        Checkbox - etats Figma, tailles small/large et liste multi-select.
      </Text>

      <Row gap="spacing.general.x3">
        <Checkbox showText={false} state="enabled" />
        <Checkbox showText={false} selected state="enabled" />
      </Row>

      <Row gap="spacing.general.x3">
        <Checkbox showText={false} state="hover" />
        <Checkbox showText={false} selected state="hover" />
      </Row>

      <Row gap="spacing.general.x3">
        <Checkbox showText={false} state="pressed" />
        <Checkbox showText={false} selected state="pressed" />
      </Row>

      <Row gap="spacing.general.x3">
        <Checkbox showText={false} state="focus" />
        <Checkbox showText={false} selected state="focus" />
      </Row>

      <Row gap="spacing.general.x3">
        <Checkbox showText={false} state="disabled" />
        <Checkbox showText={false} selected state="disabled" />
      </Row>

      <Row gap="spacing.general.x6">
        <CheckboxList
          options={OPTIONS}
          selectedValues={selectedSmall}
          onChange={(value) => setSelectedSmall((prev) => toggle(prev, value))}
          size="small"
        />
        <CheckboxList
          options={OPTIONS}
          selectedValues={selectedLarge}
          onChange={(value) => setSelectedLarge((prev) => toggle(prev, value))}
          size="large"
        />
      </Row>
    </Column>
  );
}
